import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import Icon from './red-triangle.svg';
import styles from './index.module.scss';

export class Tooltip extends Component {
  tooltip = createRef(null);

  handleHover = () => {
    this.tooltip.current.style.visibility = 'visible';
    this.tooltip.current.style.zIndex = 2;
  };

  handleMouseOut = () => {
    this.tooltip.current.style.visibility = 'hidden';
    this.tooltip.current.style.zIndex = -1;
  };

  render() {
    const { icon = Icon, children, classNameWrapper, classNameContent } = this.props;

    return (
      <div
        className={classNames(styles.tooltip, classNameWrapper)}
        onMouseOver={this.handleHover}
        onMouseOut={this.handleMouseOut}
      >
        <figure className={styles.tooltipIconWrapper}>
          <img className={styles.tooltipIcon} src={icon} alt='tooltip' />
        </figure>
        <div className={classNames(styles.tooltipContentWrapper, classNameContent)}>
          <div ref={this.tooltip} className={styles.tooltipContent}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}
